module.exports = __webpack_public_path__ + "fcc-static/media/Roboto-Bold.b8e42971dec8d49207a8c8e2b919a6ac.ttf";